module.exports = __webpack_public_path__ + "static/media/my_life_story_on_scratch.f6dc5240.png";